import { IconInvisible } from "@/components/_icons/IconInvisible";
import { SidebarNavElement } from "@/components/_templates/sidebar/sidebar-nav-element";
import { makeSettingsUrl } from "@/domain/workspace/lib/make-workspace-url";

interface FeatureFlagSidebarElementProps {
  workspace: {
    id: string;
    workspaceUrl: string;
  };
}

export const FeatureFlagSidebarElement = ({ workspace }: FeatureFlagSidebarElementProps) => {
  return (
    <SidebarNavElement to={makeSettingsUrl({ workspace, path: "account/feature-flags" })}>
      <IconInvisible className="mr-2 h-3 w-3" />
      Feature Flags
    </SidebarNavElement>
  );
};
